import React from "react";
import { Row,Col} from "reactstrap";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";

const Navlinks = () => {
  const currentPage = useSelector((state) => state.activePage);

    return (
      <Col xs={5} style={{cursor:'pointer'}}>

        <Row>         
          <Link 
            to="/" 
            className={`
              p-1 ps-3 rounded-3 responsive-fontsize fw-bold
              ${currentPage === "Produktmixern" 
                ? 'navlink-focused' 
                : 'navlink'
              }
            `} 
          >   
            UtbudsMix
          </Link>       
        </Row>

        <Row>         
          <Link 
            to="/fastaKostnader" 
            className={`
              mt-1 p-1 ps-3 rounded-3 responsive-fontsize fw-bold
              ${currentPage === "Fastakostnader" 
                ? 'navlink-focused' 
                : 'navlink'
              }
            `}         
          >   
            Fasta Kostnader
          </Link>       
        </Row>

        <Row>         
          <Link 
            to="/åtgärder" 
            className={`
              mt-1 p-1 ps-3 rounded-3 responsive-fontsize fw-bold
              ${currentPage === "Åtgärder" 
                ? 'navlink-focused' 
                : 'navlink'
              }
            `}     
          >   
            Åtgärder
          </Link>       
        </Row>

        <Row>         
          <Link 
            to="/lonekalkyl" 
            className={`
              mt-1 p-1 ps-3 rounded-3 responsive-fontsize fw-bold
              ${currentPage === "Lonekalkyl" 
                ? 'navlink-focused' 
                : 'navlink'
              }
            `}       
          >   
            Lönekalkyl
          </Link>       
        </Row>
        
      </Col>
    );
};
export default Navlinks;

